import { render, staticRenderFns } from "./Jinchukou.vue?vue&type=template&id=71169921&scoped=true&"
import script from "./Jinchukou.vue?vue&type=script&lang=js&"
export * from "./Jinchukou.vue?vue&type=script&lang=js&"
import style0 from "./Jinchukou.vue?vue&type=style&index=0&id=71169921&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71169921",
  null
  
)

export default component.exports